import { FC } from 'react';

import QffBonusCard from './QffBonusCard';
import { useCancellationQuote } from '../CancellationQuoteProvider';

const QffBonus: FC = () => {
  const { cancellation } = useCancellationQuote();
  return <QffBonusCard bonusPoints={cancellation!.creditNote!.bonusPointsTotal.amount} />;
};

export default QffBonus;
